import React, { FC, PropsWithChildren } from 'react';
import { ConfirmationModalProps } from './ConfirmationModalProps';
import Text from '@ingka/text';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import useTranslation from '../../hooks/useTranslation';
import { IconButton, Stack } from '@mui/material';
import cross from '@ingka/ssr-icon/paths/cross';
import SSRIcon from '@ingka/ssr-icon';

const ConfirmationModal: FC<PropsWithChildren<ConfirmationModalProps>> = ({
  visible,
  closeHandler,
  children,
  title,
  text,
  hideFooter,
}) => {
  const t = useTranslation();
  return (
    visible && (
      <Modal
        visible={visible}
        escapable={true}
        handleCloseBtn={closeHandler}
        data-testid={`${title.toUpperCase().split(' ').join('-')}-modal`}
      >
        <Prompt
          header={null}
          titleId={`${title.toUpperCase().split(' ').join('-')}-modal-title`}
          style={{
            width: '31.5rem',
          }}
          title={
            <Stack direction={'row'} justifyContent={'space-between'} pt={3}>
              <Stack flex={1}>{title}</Stack>
              <IconButton
                onClick={closeHandler}
                sx={(theme) => ({
                  position: 'absolute',
                  top: theme.spacing(2),
                  right: theme.spacing(2),
                })}
              >
                <SSRIcon paths={cross} />
              </IconButton>
            </Stack>
          }
          footer={
            <ModalFooter>
              {children}
              {!hideFooter && (
                <Button
                  onClick={closeHandler}
                  style={{ width: '12.5rem', marginLeft: '1rem' }}
                  text={t('common.cancel')}
                  type="secondary"
                ></Button>
              )}
            </ModalFooter>
          }
        >
          <Text>{text}</Text>
        </Prompt>
      </Modal>
    )
  );
};

export default ConfirmationModal;
